var _g, _defs, _defs2, _defs3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDep3 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 118,
  height: 96,
  viewBox: "0 0 118 96",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#dep3_svg__filter0_ddi_4438_2777)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M50 57.33C50 57.1 50.04 56.88 50.1 56.66C50.73 58.92 54.46 60.66 59 60.66C63.54 60.66 67.27 58.92 67.9 56.66C67.96 56.88 68 57.1 68 57.33C68 59.91 63.97 62 59 62C54.03 62 50 59.91 50 57.33ZM59 40.66C63.97 40.66 68 38.57 68 35.99C68 35.76 67.96 35.54 67.9 35.32C67.27 37.58 63.54 39.32 59 39.32C54.46 39.32 50.73 37.58 50.1 35.32C50.04 35.54 50 35.76 50 35.99C50 38.57 54.03 40.66 59 40.66ZM59 43.33C63.97 43.33 68 41.24 68 38.66C68 38.43 67.96 38.21 67.9 37.99C67.27 40.25 63.54 41.99 59 41.99C54.46 41.99 50.73 40.25 50.1 37.99C50.04 38.21 50 38.43 50 38.66C50 41.24 54.03 43.33 59 43.33ZM59 38C63.97 38 68 35.91 68 33.33C68 33.1 67.96 32.88 67.9 32.66C67.27 34.92 63.54 36.66 59 36.66C54.46 36.66 50.73 34.92 50.1 32.66C50.04 32.88 50 33.1 50 33.33C50 35.91 54.03 38 59 38ZM59 35.33C63.97 35.33 68 33.24 68 30.66C68 30.43 67.96 30.21 67.9 29.99C67.27 32.25 63.54 33.99 59 33.99C54.46 33.99 50.73 32.25 50.1 29.99C50.04 30.21 50 30.43 50 30.66C50 33.24 54.03 35.33 59 35.33ZM59 54C63.97 54 68 51.91 68 49.33C68 49.1 67.96 48.88 67.9 48.66C67.27 50.92 63.54 52.66 59 52.66C54.46 52.66 50.73 50.92 50.1 48.66C50.04 48.88 50 49.1 50 49.33C50 51.91 54.03 54 59 54ZM59 46C63.97 46 68 43.91 68 41.33C68 41.1 67.96 40.88 67.9 40.66C67.27 42.92 63.54 44.66 59 44.66C54.46 44.66 50.73 42.92 50.1 40.66C50.04 40.88 50 41.1 50 41.33C50 43.91 54.03 46 59 46ZM59 48.67C63.97 48.67 68 46.58 68 44C68 43.77 67.96 43.55 67.9 43.33C67.27 45.59 63.54 47.33 59 47.33C54.46 47.33 50.73 45.59 50.1 43.33C50.04 43.55 50 43.77 50 44C50 46.58 54.03 48.67 59 48.67ZM59 56.67C63.97 56.67 68 54.58 68 52C68 51.77 67.96 51.55 67.9 51.33C67.27 53.59 63.54 55.33 59 55.33C54.46 55.33 50.73 53.59 50.1 51.33C50.04 51.55 50 51.77 50 52C50 54.58 54.03 56.67 59 56.67ZM59 51.34C63.97 51.34 68 49.25 68 46.67C68 46.44 67.96 46.22 67.9 46C67.27 48.26 63.54 50 59 50C54.46 50 50.73 48.26 50.1 46C50.04 46.22 50 46.44 50 46.67C50 49.25 54.03 51.34 59 51.34ZM59 32.67C63.97 32.67 68 30.58 68 28C68 27.77 67.96 27.55 67.9 27.33C67.27 29.59 63.54 31.33 59 31.33C54.46 31.33 50.73 29.59 50.1 27.33C50.04 27.55 50 27.77 50 28C50 30.58 54.03 32.67 59 32.67ZM59 59.34C63.97 59.34 68 57.25 68 54.67C68 54.44 67.96 54.22 67.9 54C67.27 56.26 63.54 58 59 58C54.46 58 50.73 56.26 50.1 54C50.04 54.22 50 54.44 50 54.67C50 57.25 54.03 59.34 59 59.34ZM59 27.34C63.97 27.34 68 25.25 68 22.67C68 20.09 63.97 18 59 18C54.03 18 50 20.09 50 22.67C50 25.25 54.03 27.34 59 27.34ZM59 30.01C63.97 30.01 68 27.92 68 25.34C68 25.11 67.96 24.89 67.9 24.67C67.27 26.93 63.54 28.67 59 28.67C54.46 28.67 50.73 26.93 50.1 24.67C50.04 24.89 50 25.11 50 25.34C50 27.92 54.03 30.01 59 30.01ZM79 46.01C74.47 46.01 70.73 44.27 70.1 42.01C70.04 42.23 70 42.45 70 42.68C70 45.26 74.03 47.35 79 47.35C83.97 47.35 88 45.26 88 42.68C88 42.45 87.96 42.23 87.9 42.01C87.27 44.27 83.54 46.01 79 46.01ZM79 43.34C74.47 43.34 70.73 41.6 70.1 39.34C70.04 39.56 70 39.78 70 40.01C70 42.59 74.03 44.68 79 44.68C83.97 44.68 88 42.59 88 40.01C88 39.78 87.96 39.56 87.9 39.34C87.27 41.6 83.54 43.34 79 43.34ZM79 40.67C74.47 40.67 70.73 38.93 70.1 36.67C70.04 36.89 70 37.11 70 37.34C70 39.92 74.03 42.01 79 42.01C83.97 42.01 88 39.92 88 37.34C88 37.11 87.96 36.89 87.9 36.67C87.27 38.93 83.54 40.67 79 40.67ZM79 48.67C74.47 48.67 70.73 46.93 70.1 44.67C70.04 44.89 70 45.11 70 45.34C70 47.92 74.03 50.01 79 50.01C83.97 50.01 88 47.92 88 45.34C88 45.11 87.96 44.89 87.9 44.67C87.27 46.93 83.54 48.67 79 48.67ZM79 56.67C74.47 56.67 70.73 54.93 70.1 52.67C70.04 52.89 70 53.11 70 53.34C70 55.92 74.03 58.01 79 58.01C83.97 58.01 88 55.92 88 53.34C88 53.11 87.96 52.89 87.9 52.67C87.27 54.93 83.54 56.67 79 56.67ZM79 39.34C83.97 39.34 88 37.25 88 34.67C88 32.09 83.97 30 79 30C74.03 30 70 32.09 70 34.67C70 37.25 74.03 39.34 79 39.34ZM79 51.34C74.47 51.34 70.73 49.6 70.1 47.34C70.04 47.56 70 47.78 70 48.01C70 50.59 74.03 52.68 79 52.68C83.97 52.68 88 50.59 88 48.01C88 47.78 87.96 47.56 87.9 47.34C87.27 49.6 83.54 51.34 79 51.34ZM79 54.01C74.47 54.01 70.73 52.27 70.1 50.01C70.04 50.23 70 50.45 70 50.68C70 53.26 74.03 55.35 79 55.35C83.97 55.35 88 53.26 88 50.68C88 50.45 87.96 50.23 87.9 50.01C87.27 52.27 83.54 54.01 79 54.01ZM39 46C34.47 46 30.73 44.26 30.1 42C30.04 42.22 30 42.44 30 42.67C30 45.25 34.03 47.34 39 47.34C43.97 47.34 48 45.25 48 42.67C48 42.44 47.96 42.22 47.9 42C47.27 44.26 43.54 46 39 46ZM39 35.33C34.03 35.33 30 37.42 30 40C30 42.58 34.03 44.67 39 44.67C43.97 44.67 48 42.58 48 40C48 37.42 43.97 35.33 39 35.33ZM39 48.66C34.47 48.66 30.73 46.92 30.1 44.66C30.04 44.88 30 45.1 30 45.33C30 47.91 34.03 50 39 50C43.97 50 48 47.91 48 45.33C48 45.1 47.96 44.88 47.9 44.66C47.27 46.92 43.54 48.66 39 48.66ZM39 51.33C34.47 51.33 30.73 49.59 30.1 47.33C30.04 47.55 30 47.77 30 48C30 50.58 34.03 52.67 39 52.67C43.97 52.67 48 50.58 48 48C48 47.77 47.96 47.55 47.9 47.33C47.27 49.59 43.54 51.33 39 51.33ZM39 54C34.47 54 30.73 52.26 30.1 50C30.04 50.22 30 50.44 30 50.67C30 53.25 34.03 55.34 39 55.34C43.97 55.34 48 53.25 48 50.67C48 50.44 47.96 50.22 47.9 50C47.27 52.26 43.54 54 39 54ZM39 56.67C34.47 56.67 30.73 54.93 30.1 52.67C30.04 52.89 30 53.11 30 53.34C30 55.92 34.03 58.01 39 58.01C43.97 58.01 48 55.92 48 53.34C48 53.11 47.96 52.89 47.9 52.67C47.27 54.93 43.54 56.67 39 56.67ZM66.6 71.44C67.12 71.25 67.55 70.95 67.87 70.53C68.28 70.01 68.48 69.4 68.48 68.68C68.48 67.64 68.11 66.82 67.36 66.24C66.61 65.66 65.58 65.36 64.25 65.36C63.43 65.36 62.64 65.48 61.89 65.73C61.14 65.98 60.51 66.33 59.98 66.78L60.85 68.76C61.31 68.37 61.8 68.07 62.32 67.88C62.84 67.69 63.39 67.59 63.98 67.59C64.57 67.59 65.06 67.71 65.39 67.96C65.71 68.2 65.88 68.56 65.88 69.02C65.88 69.48 65.71 69.87 65.36 70.14C65.01 70.41 64.55 70.55 63.97 70.55H62.16V72.69H64.21C64.88 72.69 65.39 72.81 65.73 73.07C66.07 73.32 66.24 73.69 66.24 74.17C66.24 74.69 66.06 75.09 65.7 75.35C65.34 75.61 64.8 75.75 64.08 75.75C63.46 75.75 62.87 75.65 62.29 75.46C61.71 75.27 61.16 74.98 60.64 74.6L59.79 76.62C60.28 77.05 60.92 77.39 61.71 77.63C62.5 77.87 63.33 78 64.19 78C65.63 78 66.76 77.68 67.59 77.04C68.42 76.4 68.83 75.53 68.83 74.41C68.83 73.59 68.6 72.9 68.13 72.36C67.74 71.91 67.22 71.6 66.58 71.43L66.6 71.44ZM59.34 68.99H56.26L54.37 71.46L52.49 68.99H49.39L52.87 73.26L49.17 77.81H52.25L54.37 75.11L56.48 77.81H59.59L55.9 73.26L59.35 68.99H59.34Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "dep3_svg__filter0_ddi_4438_2777",
  x: 0,
  y: -12,
  width: 118,
  height: 120,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.808333 0 0 0 0 0.49443 0 0 0 0 0.0235764 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4438_2777"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 15
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow_4438_2777",
  result: "effect2_dropShadow_4438_2777"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect2_dropShadow_4438_2777",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect3_innerShadow_4438_2777"
})))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "dep3_svg__yellow",
  x1: 30.001,
  y1: 18,
  x2: 85.7529,
  y2: 82.4433,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.15625,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.265625,
  stopColor: "#FFDD9A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3125,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.46875,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.515625,
  stopColor: "#FFDD9A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.604167,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.875,
  stopColor: "#FFDD9A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.973958,
  stopColor: "white"
})))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "dep3_svg__gray",
  x1: 30.001,
  y1: 18,
  x2: 85.7529,
  y2: 82.4433,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.15625,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.265625,
  stopColor: "#C4C3DD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3125,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.46875,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.515625,
  stopColor: "#C4C3DD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.604167,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.875,
  stopColor: "#CECEE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.973958,
  stopColor: "white"
})))));
export { SvgDep3 as ReactComponent };
export default __webpack_public_path__ + "assets/icons/dep3.64a19d.svg";